module.exports = require("@wildboar/x500/src/lib/modules/CommonProtocolSpecification/Code.ta");